import React from 'react';
import  { GlobalRegistriesBasicInfoComponent } from './open-network-registries-basic-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import GlobalRegistriesKeypairInfoComponent from './open-network-keypair-info.component';
import OBNDBNBIZRegistries from './obn-dbn-bizs/containers/obn-dbn-bizs';
import OBNAgentsRegistries from './obn-agents/containers/obn-agents';


function GlobalRegistriesComponent ({ 
  id, handleBacicInnerFormChange, handleInnerFormChange, dbnpname, opsnumber, subDomains, domains, countries, back, handleFormSubmit, selectedDbnpRegistry 
}: any) {
    const tabItems=[
        {
            id:1,
            title:'Open Network Registry Basic Info',
            component: <GlobalRegistriesBasicInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
            dbnpname={dbnpname}
            opsnumber={opsnumber}
            subDomains={subDomains}
            domains={domains}
            countries={countries}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'KeyPair',
            component: <GlobalRegistriesKeypairInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
           isVisible:true,
        },

         {
            id:3,
            title:`${selectedDbnpRegistry?.subscriber_id} - BIZs`,
            component: <OBNDBNBIZRegistries
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
           isVisible:true,
        },
        {
            id:4,
            title:`${selectedDbnpRegistry?.subscriber_id} - Agents`,
            component: <OBNAgentsRegistries
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
           isVisible:true,
        },
      
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
      </div>
     </div>
  );
}
export default GlobalRegistriesComponent;
